module.exports = __webpack_public_path__ + "static/fonts/FontsFree-Net-SF-Pro-Rounded-Regular.400bd9f8.ttf";